// Utils
import solver from 'utilities';

// Methods
import { keyboard } from './keyboard.js';
import { navigation } from './nav.js';

window.onload = async function () {
  console.log('--Initializing Scripts');
  window.Solver = {};

  keyboard();
  navigation();

  console.log('--Scripts Loaded');
};
